//
//  demo.ts
//  moods-film-ui
//
//  Created by romain@lunii on 07/06/2020.
//  Copyright © 2020 Lunii. All rights reserved.
//

import { Vue, Component, Prop } from 'vue-property-decorator';
import lottie from 'lottie-web';

@Component
export default class About extends Vue {

    @Prop(String) private readonly videoUrl!: string;
    @Prop(String) private readonly context!: string;

    private mounted(): void {

        this.handleLottieScrollAnimation('scrollArrow');

    }

    private onScrollArrowClick(): void {

        this.$emit('on-scroll-arrow-click');

    }

    /*
     * Load the scroll arrow down animation with lottie.
     */
    private handleLottieScrollAnimation(ref: string): void {

        lottie.loadAnimation({
            container: this.$refs[ref] as HTMLElement, // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/image/lottie/scroll-arrow.json', // the path to the animation json
        });

    }

}
